import React, { useState, useEffect } from "react";
import { clsx } from "clsx";

import CloseIcon from "@src/stories/components/CloseIcon/CloseIcon";

import shopify from "frontend/js/shopify";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "@src/../entrypoints/theme";

let parentScrollPosition = 0;

export const ProductTileQuickAdd = ({ product }) => {
  const [currentVariant, setCurrentVariant] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [unavailableForShipping, setUnavailableForShipping] = useState<string[]>([]);
  const isMobile = useMobileBreakpoint(mobileBreakpoint);

  const updateCurrentVariant = (variant) => {
    setCurrentVariant(variant);
  };

  if (isMobile) {
    const parentEl = document.querySelector('.lookbook-drawer');
    parentScrollPosition = parentEl ? parentEl.scrollTop : 0;

    const action = isOpen ? 'add' : 'remove';
    document.body.classList[action]("quick-add-open");
  }
  
  useEffect(() => {
    async function fetchInvetoryDetails() {
      const variantIds = product?.variants?.map(variant => variant.id) || [];
      const response = await shopify.getInventoryDetails(variantIds);
      const nodes = response?.data?.nodes || []

      const _unavailableForShipping = nodes?.filter(node => {
        if (!node) return false;
        const inventoryLevels = node?.inventoryItem?.inventoryLevels?.nodes || [];
        const combinedStore = inventoryLevels.find(inventorylevel => inventorylevel.location?.name === "Combined Store");
        return !combinedStore || (combinedStore?.quantities?.[0]?.quantity ?? 0) <= 0;
      }).map(node => node?.id?.split("/").pop()) || [];

      setUnavailableForShipping(_unavailableForShipping);
    }

    fetchInvetoryDetails();
  }, [])

  return (
    <>
      {!isOpen && (
        <button 
          className="p-0 w-8 h-8 lg:w-[52px] lg:h-[52px] min-h-8 lg:min-h-[52px] bg-white/80 hover:bg-white rounded-full flex items-center justify-center absolute bottom-6 left-1/2 transform -translate-x-1/2 z-20"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsOpen(true);
          }}
        >
          <span className="text-sm icon-bag lg:text-2xl"></span>
        </button>
      )}

      {isOpen && product?.variants.length > 1 && (
        <div
          className={clsx(
            "transition-all duration-300 w-full cursor-default",
            {
              "fixed z-40 top-0 left-0 h-full bg-[#54565A88]": isMobile,
              "absolute bottom-0": !isMobile
            }
          )}
          style={{ top: isMobile ? `${parentScrollPosition}px` : 'auto' }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div
            className={clsx("flex flex-col gap-7 lg:gap-4 pt-10 lg:p-4 lg:backdrop-blur-[6px]", {
              'absolute bottom-0 left-0 w-full': isMobile
            })}
            style={{ background: isMobile ? "#FFF" : "rgba(255, 255, 255, 0.80)" }}
          >
            <CloseIcon
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsOpen(false);
              }}
              className="absolute w-4 h-4 cursor-pointer top-4 right-4"
            />

            <p className="text-xs text-center lg:text-sm max-lg:font-medium">
              {isMobile ? product.title : "ADD SIZE (AU)"}
            </p>

            <div className="flex flex-wrap items-center justify-center gap-7 lg:gap-6">
              {product?.variants?.map((variant) => (
                <React.Fragment key={variant.id}>
                  {variant.available && !unavailableForShipping?.includes(`${variant.id}`) ? (
                    <button
                      className={clsx("flex cursor-pointer text-sm p-0 h-auto min-h-full font-normal hover:underline", {
                        'underline': currentVariant?.id === variant.id
                      })}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        updateCurrentVariant(variant);
                      }}
                    >
                      {variant.options[1]}
                    </button>
                  ) : (
                    <div
                      className="flex items-center justify-center h-auto min-h-full p-0 text-sm font-normal text-black/40 max-lg:w-full"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault();
                      }}
                    >
                      {variant.options[1]}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <div>
              <ajax-cart-product-form>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <form
                    action="/cart/add"
                    id="product_form_id"
                    className="w-full gap-2 flex-items-center lg:text-center"
                    noValidate
                    data-prodify-product-form
                  >
                    <input type="hidden" name="id" value={`${currentVariant?.id}`} />

                    <button
                      type="submit"
                      className={clsx("text-sm font-normal min-h-full lg:p-0 lg:h-auto", {
                        'button-primary [&:not(:disabled)]:bg-[#00263E]': isMobile,
                        'hover:underline w-auto cursor-pointer disabled:opacity-50 disabled:pointer-events-none': !isMobile
                      })}
                      disabled={!currentVariant}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span>ADD TO BAG</span>
                      <span className="icon-arrow-right lg:hidden"></span>
                    </button>

                    <div
                      data-ajax-cart-errors="form"
                      className="text-xs text-error-1"
                    ></div>
                  </form>
                </div>
              </ajax-cart-product-form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductTileQuickAdd;